import { call, put, select, takeLatest } from 'redux-saga/effects';

import createInitialState from '../../../../utility/createInitialState';
import { statsConfigSelectors } from '../../config';
import { dataTableActionCreators } from '../dataTable';
import { filterActionCreators } from '../filter';
import { playersAndTeamsActionTypes } from '../index';
import { reportActionCreators } from '../report';

import { validateFields } from './runReportValidation';

function* resetPlayersAndTeamsState() {
    const config = yield select(statsConfigSelectors.getConfig);
    const { playersAndTeams } = createInitialState(config);

    yield put(reportActionCreators.hydrateCurrentReport(playersAndTeams.report.current));
    yield put(reportActionCreators.hydrateAppliedReport(playersAndTeams.report.current));
    yield put(dataTableActionCreators.hydrateSort(playersAndTeams.dataTable.sort));
    yield put(dataTableActionCreators.hydratePage(playersAndTeams.dataTable.page));
    yield put(dataTableActionCreators.hydratePageSize(playersAndTeams.dataTable.pageSize));
    yield put(filterActionCreators.hydrateFilterValues(playersAndTeams.filter.values));
    yield put(filterActionCreators.hydrateAppliedFilters(playersAndTeams.filter.values));
    yield put(filterActionCreators.setFiltersVisibility(playersAndTeams.filter.isVisible));

    yield call(validateFields);
}

function* watchResetPlayersAndTeamsState() {
    yield takeLatest(playersAndTeamsActionTypes.RESET_PLAYERS_AND_TEAMS_STATE, resetPlayersAndTeamsState);
}

export default {
    watchResetPlayersAndTeamsState: watchResetPlayersAndTeamsState(),
};
